import React, { ReactNode } from "react";
import { map, sumBy } from "lodash";
import Legend from "@charty/legend";
import { Gender } from "@linkfluence/models/gender";
import { Locale } from "@linkfluence/models/locale";

type SerieGender = Gender.Male | Gender.Female;

interface RangeData {
  range: string;
  data: {
    [Gender.Male]: number;
    [Gender.Female]: number;
  };
}

interface IProps {
  data: RangeData[];
  series: { color: string; id: SerieGender; label: string }[];
  locale?: Locale;
  tooltip?: (serie: any) => ReactNode;
  setHovered: (uid: string) => void;
  disableAnimation?: boolean;
}

const formatLegends = (series, data) =>
  map(series, (serie) => ({
    id: serie.id,
    label: serie.label,
    color: serie.color,
    count: sumBy(data, "data." + serie.id),
  }));

const DemographyLegend = React.memo(
  ({ data, series, locale, tooltip, setHovered, disableAnimation }: IProps) => {
    return (
      <Legend
        items={formatLegends(series, data)}
        locale={locale}
        setHovered={setHovered}
        disableAnimation={disableAnimation}
        magicWandCursor
      />
    );
  }
);

export default DemographyLegend;
